import React, { useContext, useEffect } from 'react'

import Collections from '../components/shared/Collections/Collections'
import Footer from '../components/shared/Footer'
import TrackingInfo from '../components/Tracking/TrackingInfo'
import TrackingSkeleton from '../components/Tracking/TrackingSkeleton'
import { DataContext } from '../context/DataContext'
import { useCompanyApi } from '../hooks/useCompanyApi'

const Tracking: React.FC = () => {
  const {
    showCollections,
    loadingCompanyData
  } = useContext(DataContext)
  const { fetchData } = useCompanyApi()

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return (
    <div className={`min-w-screen min-h-screen ${showCollections ? 'grid portrait:grid-cols-1 grid-cols-2' : 'flex flex-col items-center justify-center'} pt-10 gap-2 md:px-28 md:pb-32`}>
      {loadingCompanyData ?
        <div className={`${showCollections ? 'w-full' : 'landscape:w-3/5 w-full'}`}>
          <TrackingSkeleton />
        </div> : <>
          <div className={`${showCollections ? 'w-full' : 'landscape:w-3/5 w-full'}`}>
            <TrackingInfo />
          </div>
          {showCollections && (
            <div className='w-full min-w-0 h-full flex flex-col'>
              <Collections footer />
            </div>
          )}
        </>}

      <div className={`landscape:hidden ${loadingCompanyData ?? 'portrait:mt-20'} flex items-center justify-center mb-4`}>
        <Footer />
      </div>
    </div>
  )
}

export default Tracking
